import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { getIn } from "formik";
import React from "react";
import CustomTextArea from "../../../../../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../../../../../components/Flex";
import OutlineCard from "../../../../../../../../../../../../../components/OutlineCard";
import Text from "../../../../../../../../../../../../../components/Text";
import { PSYCHIATRIC_HISTORY_SECTIONS } from "./PsychiatricEvolutionFormConstant";

interface PsychiatricHistorySectionProps {
  formik: any;
}

// 3 columns, matching the Physical Assessment section card UI
const columnSize = 12 / 3;

// The backend expects each section as a comma-separated string of the
// selected option names, e.g. { pastPsychodynamicHistory: "a,b,c" }.
const parseSelected = (value: unknown): string[] =>
  typeof value === "string" ? value.split(",").filter(Boolean) : [];

const PsychiatricHistorySection: React.FC<PsychiatricHistorySectionProps> = ({
  formik,
}) => (
  <Flex flexDirection="column" gap={2} width="100%">
    {PSYCHIATRIC_HISTORY_SECTIONS.map((section) => {
      const selected = parseSelected(getIn(formik.values, section.key));

      const toggleOption = (name: string, checked: boolean) => {
        // rebuild in the canonical item order so the string is stable
        const next = section.items
          .map((it) => it.name)
          .filter((n) => (n === name ? checked : selected.includes(n)));
        formik.setFieldValue(section.key, next.join(","));
      };

      return (
        <OutlineCard key={section.key}>
          <Flex flexDirection="column" gap={1} width="100%">
            <Text variant="subtitle1" fontWeight="bold">
              {section.label}
            </Text>

            <Grid container spacing={0.2}>
              {section.items.map((item) => (
                <Grid
                  key={item.name}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: columnSize,
                  }}
                >
                  <FormControlLabel
                    sx={{ mr: 0 }}
                    control={
                      <Checkbox
                        sx={{ py: 0.25 }}
                        name={`${section.key}.${item.name}`}
                        checked={selected.includes(item.name)}
                        onChange={(_, checked) =>
                          toggleOption(item.name, checked)
                        }
                      />
                    }
                    label={<Text fontSize="14px">{item.label}</Text>}
                  />
                </Grid>
              ))}

              <Grid
                sx={{
                  mt: 1,
                }}
                size={12}
              >
                <CustomTextArea
                  label="Add Note"
                  name={`${section.key}Note`}
                  placeholder={`Notes for ${section.label}...`}
                  value={getIn(formik.values, `${section.key}Note`) || ""}
                  onChange={(e) =>
                    formik.setFieldValue(`${section.key}Note`, e.target.value)
                  }
                  minRows={2}
                />
              </Grid>
            </Grid>
          </Flex>
        </OutlineCard>
      );
    })}
  </Flex>
);

export default PsychiatricHistorySection;
